__turbopack_context__.v({
  "close": "frQu6a_close",
  "footnote": "frQu6a_footnote",
  "modal": "frQu6a_modal",
});
